<template>
    <div class="filters-container">
        <!-- Header compacto con switch y botón de expandir -->
        <div class="filters-header">
            <b-form-checkbox
                v-model="localFilters.applyToCalculations"
                switch
                size="sm"
                class="apply-switch"
                @change="emitChange"
            >
                Afectar conteos
            </b-form-checkbox>

            <button class="toggle-btn" @click="showAdvanced = !showAdvanced">
                <i
                    :class="
                        showAdvanced ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
                    "
                ></i>
                {{ showAdvanced ? "Menos filtros" : "Más filtros" }}
            </button>
        </div>

        <!-- Filtros básicos (siempre visibles) -->
        <div class="filters-grid">
            <!-- Filtro por Pilar -->
            <div>
                <el-select
                    v-model="localFilters.pillarId"
                    placeholder="Todos los pilares"
                    filterable
                    clearable
                    size="small"
                    @change="emitChange"
                >
                    <el-option
                        v-for="pillar in pillars"
                        :key="pillar.id"
                        :label="pillar.name"
                        :value="pillar.id"
                    />
                </el-select>
            </div>

            <!-- Filtro por Elemento -->
            <div>
                <el-select
                    v-model="localFilters.elementId"
                    placeholder="Todos los elementos"
                    filterable
                    clearable
                    size="small"
                    :disabled="filteredElements.length === 0"
                    @change="emitChange"
                >
                    <el-option
                        v-for="element in filteredElements"
                        :key="element.id"
                        :label="element.name"
                        :value="element.id"
                    />
                </el-select>
            </div>

            <!-- Filtro por Estado -->
            <div>
                <el-select
                    v-model="localFilters.ratingId"
                    placeholder="Todos los estados"
                    clearable
                    size="small"
                    @change="emitChange"
                >
                    <el-option
                        v-for="rating in ratingOptions"
                        :key="rating.id"
                        :label="rating.name"
                        :value="rating.id"
                    />
                </el-select>
            </div>
        </div>

        <!-- Filtros avanzados (colapsables) -->
        <transition name="expand">
            <div v-if="showAdvanced" class="filters-grid advanced">
                <!-- Filtro por Ruta -->
                <div>
                    <el-select
                        v-model="localFilters.tourRouteId"
                        placeholder="Todas las rutas"
                        clearable
                        filterable
                        size="small"
                        @change="emitChange"
                    >
                        <el-option
                            v-for="route in tourRoutes"
                            :key="route.id"
                            :label="route.name"
                            :value="route.id"
                        />
                    </el-select>
                </div>

                <!-- Filtro por Criterio Transversal -->
                <div>
                    <el-select
                        v-model="localFilters.crossCuttingId"
                        placeholder="Todos los criterios"
                        clearable
                        filterable
                        size="small"
                        @change="emitChange"
                    >
                        <el-option
                            v-for="criteria in crossCuttingCriteria"
                            :key="criteria.id"
                            :label="criteria.name"
                            :value="criteria.id"
                        />
                    </el-select>
                </div>

                <!-- Búsqueda -->
                <div>
                    <el-input
                        v-model="localFilters.search"
                        placeholder="Buscar ítems..."
                        clearable
                        size="small"
                        @input="emitChange"
                    />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "DiagnosticFiltersCompact",
    props: {
        value: {
            type: Object,
            required: true,
        },
        filtersData: {
            type: Object,
            default: () => ({
                pillars: [],
                elements: [],
                tour_routes: [],
                cross_cutting_criteria: [],
                ratings: [],
            }),
        },
    },
    data() {
        return {
            showAdvanced: false,
            localFilters: {
                applyToCalculations: false,
                ...this.value,
            },
        };
    },
    computed: {
        pillars() {
            return (this.filtersData && this.filtersData.pillars) || [];
        },
        elements() {
            return (this.filtersData && this.filtersData.elements) || [];
        },
        filteredElements() {
            if (!this.localFilters.pillarId) {
                return this.elements;
            }
            return this.elements.filter(
                (element) => element.pillar_id === this.localFilters.pillarId
            );
        },
        tourRoutes() {
            return (this.filtersData && this.filtersData.tour_routes) || [];
        },
        crossCuttingCriteria() {
            return (
                (this.filtersData && this.filtersData.cross_cutting_criteria) ||
                []
            );
        },
        ratingOptions() {
            return (this.filtersData && this.filtersData.ratings) || [];
        },
    },
    watch: {
        value: {
            handler(newVal) {
                this.localFilters = {
                    applyToCalculations: false,
                    ...newVal,
                };
            },
            deep: true,
        },
        "localFilters.pillarId"(newVal) {
            if (!newVal) {
                return;
            }
            const matchesElement = this.filteredElements.some(
                (element) => element.id === this.localFilters.elementId
            );
            if (!matchesElement) {
                this.localFilters.elementId = null;
                this.emitChange();
            }
        },
    },
    methods: {
        emitChange() {
            this.$emit("input", { ...this.localFilters });
        },
        clearFilter(filterName) {
            if (filterName === "search") {
                this.localFilters[filterName] = "";
            } else {
                this.localFilters[filterName] = null;
            }
            this.emitChange();
        },
    },
};
</script>

<style scoped>
.filters-container {
    background: transparent;
    border: none;
    padding: 0;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 10px;
}

/* Header compacto */
.filters-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.apply-switch {
    margin: 0;
    font-size: 13px;
}

.toggle-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    font-size: 12px;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s;
}

.toggle-btn:hover {
    background: #f3f4f6;
    border-color: #d1d5db;
}

.toggle-btn i {
    font-size: 10px;
}

/* Grid de filtros */
.filters-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.filters-grid.advanced {
    margin-top: 8px;
}

/* Animación de expansión */
.expand-enter-active,
.expand-leave-active {
    transition: all 0.3s ease;
    max-height: 200px;
    overflow: hidden;
}

.expand-enter,
.expand-leave-to {
    max-height: 0;
    opacity: 0;
}

/* Responsive */
@media (max-width: 992px) {
    .filters-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 576px) {
    .filters-grid {
        grid-template-columns: 1fr;
    }

    .filters-header {
        flex-direction: column;
        gap: 8px;
        align-items: stretch;
    }

    .toggle-btn {
        justify-content: center;
    }
}
</style>
